import { ApiResponse, PaginatedCollection, directusApi } from '@/api';

export interface File {
    id?: number;
    filename_download: string;
    title: string;
    type: string;
    filesize: string;
}

export interface FileState {
    allFiles: Array<File>;
    allFilesLoading: boolean;
    filesPerPage: number;
    filesPage: number;
    filesTotal: number;
}

const state: FileState = {
    allFiles: [],
    allFilesLoading: false,
    filesPerPage: 1,
    filesPage: 1,
    filesTotal: 1
};

const mutations = {
    toggleAllFilesLoading(state: FileState, data: boolean) {
        state.allFilesLoading = data;
    },
    setAllFiles(state: FileState, data: PaginatedCollection) {
        state.allFiles = data.items.map(file => {
            return {
                ...file,
                url: `https://directus.prodelec.app/assets/${file.id}`,
            }
        });
        state.filesPerPage = data.perPage;
        state.filesPage = data.currentPage;
        state.filesTotal = data.totalItems;
    },
};

const actions = {
    async getAll({ _, commit }: any, { pagef, search }: any) {
        commit('toggleAllFilesLoading', true);
        let limit = 18;
        let params = '';
        if (search) {
            params += `&search=${search}`;
        }
        params += `&meta=total_count&meta=filter_count`;
        if (pagef) params += `&limit=${limit}&offset=${(pagef - 1) * limit}`;
        // console.log({ params });
        await directusApi('GET', `files?${params}`)
            .then(res => {
                // console.log('all files => ', res.data);
                commit('setAllFiles', {
                    items: res.data.data,
                    perPage: limit,
                    currentPage: pagef,
                    totalItems: res.data.meta.filter_count
                });
            })
            .catch(err => {
                console.log(err);
            })
            .finally(() => {
                commit('toggleAllFilesLoading', false);
            });
    },
};

export default {
    namespaced: true,
    state,
    actions,
    mutations,
};
